import { ENV } from "../../../utils/EmpUtil";
import {
  PREPROD_DYNATRACE_URL,
  PROD_DYNATRACE_URL,
} from "../../../common/Constants";

const initDynatrace = () => {
  // Add preconnect link
  const preconnectLink = document.createElement("link");
  preconnectLink.rel = "preconnect";
  preconnectLink.href = new URL(
    ENV !== "prod" ? PREPROD_DYNATRACE_URL : PROD_DYNATRACE_URL
  ).origin;
  document.head.appendChild(preconnectLink);

  // Create and append script
  const script = document.createElement("script");
  script.src = ENV !== "prod" ? PREPROD_DYNATRACE_URL : PROD_DYNATRACE_URL;
  script.async = true;
  document.head.appendChild(script);
};

export { initDynatrace };
